import {
  SET_ENTITY,
  RESET_LIST_DT_STATE
} from "@/store/mutation-types";
import { QTY_DT_PER_PAGE, LOCAL_FILTERS_DEFAULT, GLOBAL_FILTERS_DEFAULT } from "@/common/const.js"

const module = "ListDT";


const initialState = () => {

  let lFilters = {...LOCAL_FILTERS_DEFAULT};

  let glFilters = {...GLOBAL_FILTERS_DEFAULT};

  const sFilters = localStorage.getItem('lcFiltersDT');
  if (sFilters != null) {
    lFilters = JSON.parse(sFilters)
    if (lFilters.statuses == null) lFilters.statuses = []
  }

  const sGlFilters = localStorage.getItem('glFiltersDT');
  if (sGlFilters != null) {
    glFilters = JSON.parse(sGlFilters)
  }

  let period = glFilters.period
  if (isNaN(period) || period === 0 || period === undefined ) glFilters.period = 10; 

  let cPage = parseInt(localStorage.getItem('currentPage'));
  if (isNaN(cPage) || cPage === 0 || cPage === undefined ) cPage = 1; 

  return {
    list: [],
    listStatuses: [],
    listProcedures: [],
    listFiltered: [],
    lcFilters: lFilters,
    glFilters: glFilters,
    currentPageDT:[],
    currentPage : cPage,
    filtered : false,
    onceLoad: false,
    currentSort: {
      field: "dates",
      asc: true
    }
  }
}

const filterByAnyValue = (value) => {
  if (value == '') return () => true;
  const val = value.toLowerCase()
  return (dt) => {
    return dt.anyvalue.toLowerCase().includes(val)
  }
}

const filterByRegNo = (value) => {
  if (value == '') return () => true;
  return (dt) => {
    if (dt.regnum == '' || dt.regnum == undefined) return false;
    return dt.regnum.includes(value)
  }
}

const filterByDates = (value) => {
  if (value.length === 0) return () => true; 
  return (dt) => {
    // if (dt.datedt == '') return false;
    if (dt.datedt == '') return false;
    let res = true;
    
    const dDT = dt.datedt;
    if (value[0]) res *= dDT >= value[0]
    if (value[1]) res *= dDT <= value[1]

    return res
  }
}

const filterByStatuses = (value) => {
  if (value.length === 0) return () => true;
  return (dt) => {
    if (dt.statused == '' || dt.statused == undefined) return false;
    return value.indexOf(dt.statused) !== -1;
  }
}

const filterByProcedures = (value) => {
  if (value.length === 0) return () => true;
  return (dt) => {
    if (dt.edproc == '' || dt.edproc == undefined ) return false;
    return value.indexOf(dt.edproc) !== -1;
  }
}

const returnFilterFuncByName = function (name, value) {
  switch(name) {
    case 'anyvalue': {  
      return filterByAnyValue(value)
    }
    case 'regno': {  
      return filterByRegNo(value)
    }
    case 'dates': {
      return filterByDates(value)
    } 
    case 'statuses': {
      return filterByStatuses(value)
    } 
    case 'procedures': {
      return filterByProcedures(value)
    } 
    default:
      return () => { true };
  }
}  

const getfiltersFuncs = function (filters) {
  let funcs = [];
  for (let [key, value] of Object.entries(filters)) {
    if (value.length === 0 ) continue;
    funcs.push(returnFilterFuncByName(key, value))    
  }

  // let v = [() => true]
  if (funcs.length === 0) return null
  if (funcs.length === 1) return (dt) => funcs[0](dt)
  return (dt) => funcs.reduce((a,b) => a(dt) && b(dt))
}


export default {
  namespaced: true,
  state: initialState(),

  getters: {
    isListdataDTLoading(state) {
      return (
        !state.list.length 
      );
    },



    getDTforPage(state) {
      const endIndex = state.currentPage * QTY_DT_PER_PAGE;
      if (state.filtered) {
        return state.listFiltered.slice(endIndex - QTY_DT_PER_PAGE, endIndex);
      }
      return state.list.slice(endIndex - QTY_DT_PER_PAGE, endIndex)
    },

    getList(state) {
      if (state.filtered) {
        return state.listFiltered
      }
      return state.list
    },

    getQtyPages(state) {
      let i = 0
      if (state.filtered) {
        i = state.listFiltered.length / QTY_DT_PER_PAGE
      } else {
        i = state.list.length / QTY_DT_PER_PAGE;
      }
      
      let res = Math.trunc(i);

      if (i - res > 0) {
        res++;
      }
      return res

    },

    sidebarDTCount:
      state => state.list.length,
      getDTById(state, getters) {
      return state.currentPageDT.find(dt => +dt.nd === +getters.selectedDT.nd)
    },
  },

  mutations: {
    [RESET_LIST_DT_STATE](state) {
      Object.assign(state, initialState());
    }
  },

  actions: {
    selectedDT({state, dispatch}, nd) {
      let dt = state.currentPageDT.find((item) => item.nd === nd);
      if (!dt) {
        // Если в следствие каких-то причинЮ поменялась текущая страница и наша ДТ выпалаЮ меняем текущую страницу
        // ищем текущую страницу по nd
        dispatch('changeCurrentPageByND', nd)
        dt = state.currentPageDT.find((item) => item.nd === nd);
      } 
      
      return dt;
    },

    sortList ({state, commit, getters}, sort = state.currentSort) {
      if (!sort) sort = {
        field: 'statuses',
        asc: true
      }


      let currentList = [];

      const saveChanges = function () {
        if (state.filtered) {
          commit(
            SET_ENTITY,
            {
              module,
              entity: "listFiltered",
              value: currentList,
            },
            { root: true }
          );
        }
        if (!state.filtered) {
          commit(
            SET_ENTITY,
            {
              module,
              entity: "list",
              value: currentList,
            },
            { root: true }
          );
        }
        commit(
          SET_ENTITY,
          {
            module,
            entity: "currentSort",
            value: sort,
          },
          { root: true }
        );
        commit(
          SET_ENTITY,
          {
            module,
            entity: "currentPageDT",
            value: getters.getDTforPage,
          },
          { root: true }
        );
      } 


      if (state.filtered) {
        currentList  = [...state.listFiltered];
      }
      if (!state.filtered) {
        currentList  = [...state.list];
      }
      if (sort.field === state.currentSort.field) {
        // if (sort.asc === state.currentSort.asc) return;

        if (sort.asc !== state.currentSort.asc) {
          currentList.reverse();
          saveChanges();
          return
        }
      } 


      const y = sort.asc ? -1 : 1;
      switch(sort.field) {

        case 'regno': {  
          currentList.sort((a,b) => {
            if (a.nregdate > b.nregdate)  return y
            if ((a.nregdate === b.nregdate) && (a.numpp > b.numpp)) return y
            if ((a.nregdate === b.nregdate) && (a.numpp === b.numpp))  return 0
            return -y
          });
          break
        } 
        case 'declarant': {  
          currentList.sort((a,b) => {
            if (a.declarant > b.declarant)  return y
            if (a.declarant === b.declarant)   return 0
            return -y
          });
          break
        } 
        case 'dates': {
          currentList.sort((a,b) => {
            if (a.nlmdate > b.nlmdate)  return y
            if (a.nlmdate === b.nlmdate) return 0
            return -y 
          });
          break
        }
        case 'statuses': {
          currentList.sort((a,b) => {
            if (a.nlmdate > b.nlmdate)  return y
            if ((a.nlmdate === b.nlmdate) * (a.statused > b.statused)) return y
            if ((a.nlmdate === b.nlmdate) * (a.statused === b.statused)) return 0
            return -y 
          });
          break
        } 
        case 'procedures': {
          currentList.sort((a,b) => {
            if (a.edproc > b.edproc)  return y
            if (a.edproc === b.edproc) return 0
            return -y 
          });
          break
        } 
        default:
          return
      }    
      saveChanges();
      
    },
    resetBuilderState({ commit }) {
      commit(RESET_LIST_DT_STATE);
    },

    saveFilterState ({state, commit}, {lcFilters, filteredList = [], filtered = false}) {

      // Записываем состояния в хранилище
      commit(
        SET_ENTITY,
        {
          module,
          entity: "filtered",
          value: filtered,
        },
        { root: true }
      );      
      commit(
        SET_ENTITY,
        {
          module,
          entity: "lcFilters",
          value: lcFilters,
        },
        { root: true }
      );
      commit(
        SET_ENTITY,
        {
          module,
          entity: "listFiltered",
          value: filteredList,
        },
        { root: true }
      );

      localStorage.setItem('lcFiltersDT', JSON.stringify(state.lcFilters));

    },

    filterData ({state, dispatch}, {name, value, reset}) {
      let currentList; 
      let fullFilter = true;
      let filterFunc = () => true;
      let filtered = false;
      let filters = {...state.lcFilters};
      // Если фильтр по данному признаку не накладывался и данные уже фильтровались, используем то что уже отфильтровано
      // Иначе фильтруем исходные данные по полной
      if (!reset && filters[name].length === 0 && state.filtered) {
        currentList = [...state.listFiltered]
        fullFilter = false;
      } else {
        currentList = [...state.list]
      }

      // Запоминаем наш фильтр. Если стоит признак сброса, и передали какое-то значение, то сбрасываем значение
      value = (reset) ? '':value;
      filters[name] = value;

      if (!fullFilter) { 

        const f = returnFilterFuncByName(name, value)
        filterFunc = f
      }

      
      if (fullFilter) {
        filterFunc = getfiltersFuncs(filters)
      }


      if (filterFunc != null)  {
        currentList = currentList.filter((dt) => filterFunc(dt))
        filtered = true
      }  
      // currentList.sort ((x,y) => new Date(x.datedt) - new Date(y.datedt))

      dispatch ('saveFilterState', {
        lcFilters: filters,
        filteredList: filtered ? currentList : [],
        filtered: filtered
      });
      dispatch('sortList');
      dispatch('changeCurrentPage', 1);
    },

    changeCurrentPageByND({state, dispatch}, nd) {
      let list = state.list
      if (state.filtered) {
       list = state.listFiltered
      }
      const i = list.findIndex((item) => item.nd === nd);
      const currentPage = Math.floor(i/QTY_DT_PER_PAGE) + 1;
      dispatch("changeCurrentPage", currentPage)
    },

    changeCurrentPage({commit, getters}, newValue = 1) {
      commit(
        SET_ENTITY,
        {
          module,
          entity: "currentPage",
          value: newValue,
        },
        { root: true }
      );
      commit(
        SET_ENTITY,
        {
          module,
          entity: "currentPageDT",
          value: getters.getDTforPage,
        },
        { root: true }
      );
      localStorage.setItem('currentPage', newValue);
      
    },

    changePeriodForLoad({state, dispatch}, value) {
      let fg = {...state.glFilters}
      fg.period = value;
      dispatch('changeGlFilters', fg);
    },
    
    changeGlFilters ({state, commit, dispatch}, fg) {
      commit(
        SET_ENTITY,
        {
          module,
          entity: "glFilters",
          value: fg,
        },
        { root: true }
      );
      localStorage.setItem('glFiltersDT', JSON.stringify(state.glFilters));
      dispatch('fetchListDT');
    },

    changeLcFilters ({state, commit}, fl) {
      commit(
        SET_ENTITY,
        {
          module,
          entity: "lcFilters",
          value: fl,
        },
        { root: true }
      );
      localStorage.setItem('lcFiltersDT', JSON.stringify(state.lcFilters));
    },

    async fetchListDT({ state, commit, dispatch, getters }) {
      const params = {...state.glFilters}
      // params.numCont = "5277947"
      // убираем пустые сво-ва
      for(var key in params) {
        if(params[key] == "") {
           delete params[key]
        }
      }

      let filteredItems = [];
      const items = await this.$api.dcl.getListDT(params);
      
      let statuses = new Set()
      let edprocedures = new Set()

      items.map((dt) => {
        !dt.statused || statuses.has(dt.statused) ? false : statuses.add(dt.statused);
        !dt.edproc || edprocedures.has(dt.edproc) ? false : edprocedures.add(dt.edproc);
        
        const rd = dt.regnum ? dt.regnum.split('/')[1] : '';
        const rn = dt.regnum ? Number(dt.regnum.split('/')[2]) : 0;
        dt.nregdate = Number(rd ? new Date('20' + rd.slice(4,6)+ '-' + rd.slice(2,4) + '-' +  rd.slice(0,2)) : new Date(dt.datedt))
        dt.numpp = rn ? rn : 0;

        dt.anyvalue = dt.edproc + dt.regnum + dt.statused +  dt.dopstatused + dt.recipient + dt.fiodecl + dt.kodto + dt.declarant;
        dt.datedt = new Date(dt.datedt)
        // dt.lastmsgdate = new Date(dt.lastmsgdate + "+03:00")
        // console.log(dt.lastmsgdate.setHours(dt.lastmsgdate.getHours() - 3));
        dt.nlmdate = Number(dt.lastmsgdate)
      })

      const st = Array.from(statuses).sort()
      const pr = Array.from(edprocedures).sort();

      dispatch('sortList');
      commit(
        SET_ENTITY,
        {
          module,
          entity: "list",
          value: items,
        },
        { root: true }
      );
      commit(
        SET_ENTITY,
        {
          module,
          entity: "listStatuses",
          value: st,
        },
        { root: true }
      );
      commit(
        SET_ENTITY,
        {
          module,
          entity: "listProcedures",
          value: pr,
        },
        { root: true }
      );

      //филтруем данные по сохраненным фильтрам
      let filters = {...state.lcFilters};
      let filterFunc = getfiltersFuncs(filters)
      if (filterFunc != null)  {
        filteredItems = items.filter((dt) => filterFunc(dt))
        dispatch ('saveFilterState', {
          lcFilters: state.lcFilters,
          filteredList: filteredItems,
          filtered: true
        });
      } 
      if ((filterFunc == null) && (state.filtered === true)) {
        dispatch ('saveFilterState', {
          lcFilters: state.lcFilters,
          filteredList: [],
          filtered: false
        });
      }

      // Обновляем данные для текущей страницы, но если период меняется в меньшую сторонуЮ то данных может быть меньше, тогда переходим на первую
      let ldt = getters.getDTforPage;
      if (ldt.length === 0) {
        dispatch("changeCurrentPage", 1)
      } else {
        commit(
          SET_ENTITY,
          {
            module,
            entity: "currentPageDT",
            value: ldt,
          },
          { root: true }
        );
      }



    },

    async autoRefresh ({state, dispatch}, delay = 300000) {

      const refreshFullList = function() {
        if (state.currentPage != 1) return;
        dispatch('fetchListDT');   
      }

      const intervalID = setInterval(refreshFullList, delay)

      const close = function () {
        clearInterval(intervalID)
      } 
      return close
    },

    async loadListDataOnce({state, dispatch, commit}) {
      
      if (state.onceLoad) {
        return false
      }
      await dispatch('fetchListDT');

      commit(
        SET_ENTITY,
        {
          module,
          entity: "onceLoad",
          value: true,
        },
        { root: true }
      );
      return true
    },
    async refreshListData({dispatch}) {
      
      await dispatch('fetchListDT');

      return true
    }
  },
};